var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contextMenu",staticClass:"context-menu",class:'context-menu--' + _vm.flowDirection,style:(_vm.position),attrs:{"tabindex":"0"},on:{"focusin":_vm.focusIn,"focusout":_vm.focusOut}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a232eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/ui-kit/components/ContextMenu/ContextMenu.vue
// module id = null
// module chunks = 